import { combineReducers } from "redux-immutable";
import { ActivateAccount } from "./modules";

export default combineReducers({
    appState: combineReducers({
        activateAccount: ActivateAccount.reducer,
    }),
});
